import { Routes } from 'src/Routes.constants';
import { StickyLinkCell } from 'src/common/components/ConfigurableTable/Components/Cells/StickyLinkCell';

export const RSimEIDLinkCell = ({ value }: any) => {
  return (
    <div data-testid="primaryText">
      <StickyLinkCell value={value || '-'} to={`${Routes.productsRsim}/${value}`} />
    </div>
  );
};
